module.exports = "<div class=\"notification\" [ngClass]='type' *ngIf=\"_text != '' && _text != null\">\n\t<p> {{ text }} </p>\n</div>"